export const es = {
  texts: {
    text1: `Si tienes problemas con tu cámara o micrófono, por favor, revisa los permisos de tu navegador.`,
    text2: `Links de ayuda para navegador:`,
  },
};
